export class UserPruBE {
    Id: number =-1;
    PruId: number = -1;
    UserId: string = "";
    UserName: string = "";
    IsApprover: boolean = false;    
}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/user-management/shared/user-management.model.ts